/**
* filters Module
*
* Description
*/
var app = angular.module('filters');

    app.filter('currencyUAH', [
        '$filter',
        function ($filter) {
            return function (string) {
                var numberArray = [],
                    number = (string || string === 0) ? string.toString().replace(/,/g, '.') : '';

                numberArray =  number.toString().split('.');
                number = numberArray[0] + (numberArray[1] ? '.' + numberArray[1].slice(0, 2) : '');
                number = parseFloat(number);

                if (isNaN(number) || !isFinite(number)) {
                    number = 0;
                }

                number = (number < 0 ? '-' : '') +
                    $filter('currency')(Math.abs(number), '').replace(/,/g, ' ').replace(/\./, ',');
                return number;
            };
        }
    ]);

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/filters/currencyuah.filter.js
 ** module id = 244
 ** module chunks = 1
 **/